import reducer from './reducers';

export { default as deleteResourceSelectors } from './selectors';
export { default as deleteResourceOperations } from './operations';
export { default as deleteResourceTypes } from './types';

export default reducer;
